import { CURRENCY } from "../selecters";

export const handleCurrency = (data) => async (dispatch) => {
    dispatch({
        type: CURRENCY, payload: data
    });
};